<template>
  <div class="flex flex-col">
    <div class="bg-transparent md:bg-white p-0 md:p-5 rounded">
      <div class="block md:hidden mb-10" v-if="showOrgImage">
        <img alt="Organization" :src="imgSrc" />
      </div>
      <h2 class="text-2.5xl font-sans-bold text-n-gray-dark font-hairline mb-6">
        {{organization.name}}
      </h2>
      <div class="flex">
        <div class="w-full md:w-1/2">
          <div class="pl-4">
            <div v-if="hasCompleted">
              <div v-if="organization.city">{{organization.city}}<span v-if="organization.state">, {{organization.state}}</span></div>
              <div v-if="country && country.name">{{country.name}}</div>
              <div v-if="organization.url">
                <NewTabA11y :href="organization.url">Website</NewTabA11y>
              </div>
              <div v-if="organization.publicEmail">
                <a :href="`mailto:${organization.publicEmail}`">
                  {{organization.publicEmail}}
                </a>
              </div>
            </div>
            <div v-else>
              <h3 class="text-n-gray-dark text-2xl font-hairline" style="line-height: 32px">
                Add your <br />details here
              </h3>
            </div>
          </div>
        </div>
        <div class="hidden md:block w-1/2 text-right pr-4" v-if="showOrgImage">
          <img class="text-right" :src="imgSrc" alt="Profile shot" width="175"  />
        </div>
      </div>
      <div>
        <div v-if="!hasCompleted" class="mb-4 pl-4 mt-4 md:mt-0">
          Add your social links
        </div>
        <div class="flex flex-row space-x-2 mb-4 pl-4 mt-4">
          <SocialIcon :has-completed="hasCompleted" type="instagram" :link="organization.instagramUrl" />
          <SocialIcon :has-completed="hasCompleted" type="facebook" :link="organization.facebookUrl" />
          <SocialIcon :has-completed="hasCompleted" type="twitter" :link="organization.twitterUrl" />
          <SocialIcon :has-completed="hasCompleted" type="linkedin" :link="organization.linkedinUrl" />
        </div>
      </div>
    </div>
    <div class="mt-0 md:mt-5 pl-0">
      <div class="flex flex-wrap">
        <EventEditBtn :completed="hasCompleted" @click="modalOpen=true">
          Add your details
        </EventEditBtn>
        <div class="px-3" />
          <a class="button button-secondary button__medium mb-2" :href="organization.profileUrl">
            View Profile
          </a>
        </div>
      </div>
    <OrganizationEditModal v-model="modalOpen" />
  </div>
</template>

<script>
import { geocodeAPI } from "../../../../api/geocodeAPI";
import SocialIcon from "./SocialIcon";
import OrganizationEditModal from "./modals/OrganizationEditModal.vue";
import PencilIcon from "../../../icons/PencilIcon.vue";
import NewTabA11y from "../../../global/a11y/NewTabA11y.vue";
import EventEditBtn from "../event/EventEditBtn.vue";

export default {
  components: {EventEditBtn, NewTabA11y, PencilIcon, OrganizationEditModal, SocialIcon },
  props: {
    organization: {
      required: true,
      type: Object
    },
    hasCompleted: {
      required: true,
      type: Boolean
    },
  },
  name: "OrganizationCard",
  computed: {
    country() {
      return geocodeAPI.getCountry(this.organization.country_code);
    },
    imgSrc() {
      // noinspection JSUnresolvedVariable
      return this.organization.profilePhoto ? this.organization.profilePhoto : '/img/profile/image_placeholder.png';
    },
    showOrgImage() {
      return this.hasCompleted ? !!this.organization.profilePhoto : true;
    }
  },
  data() {
    return { modalOpen: false };
  },
}
</script>

<style scoped>

</style>